<template>
  <Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
  >
    <template slot="header">
      
    </template>
    <template slot="body">

      <div class="ut-flex">
        <TextField
          style="flex:1"
          class="m1"
          required
          :id="'searchString'"
          v-bind="textFieldConfig"
          :value="searchString"
          :placeholder="$t('search')"
          @keyup="onSearchInputKeyup"
        
        >
        </TextField>
        <Dropdown
          style="flex:1;margin-left:20px"
          :options="productTypesTV"
          class="group-input m2"
          id="product_type_id"
          :placeholder="$t('select_category')"
          :selected="productTypesTV.find(e=>e.value==product_type_id)"
          v-on:selectedChange="(e) => onDropdownChange('product_type_id',e)"
          box            
          :listHeight="250"
        >
        </Dropdown>
        
        
      </div>

            <div class="ut-fh ut-fc" style="max-height:300px;height:300px">
             <NTable
                id="catalog-releases-releases_list"
                class="h1"
                :config="tableConfig"
                :headers="Headers"
                :items="list"
                thpad="0px"
                tdpad="0px"
                thspad="0px 10px 0px 10px"
                tdbdr="1px solid var(--sprt-12)"
                
            >
                <template v-slot:item="{ item, tdcon }">
                <tr>
                  <td v-bind="tdcon('catalog_no')">
                    <span>{{item['catalog_no']}} </span>
                  </td>
                  <td v-bind="tdcon('artist')">
                    <span>{{item['release_artist']}}</span>
                  </td>

                  <td v-bind="tdcon('title1')">
                      <span>{{item['release_title'] }}</span>
                  </td>
                  <td v-bind="tdcon('format')">
                    <span class="txtov" :title="item['format_name']">{{item['format_name']}}</span>
                  </td>
                   
                  <td v-bind="tdcon('cost_price')">
                        <span>{{ item["cost_price"] }}</span>   
                  </td>

                  <td v-bind="tdcon('order_qty')">
                    <TextField2
                      type="text"
                      class="dbox1"
                      id="order_qty"
                      :showLabel="false"
                      :disabled="false"
                      :value="item['order_qty']||0"
                      :bb="'0px'"
                      @change="e => onTextFieldChange(e, item)"
                    />  
                  </td>

                  <td v-bind="tdcon('foc')">
                    <TextField2
                      type="text"
                      class="dbox1"
                      id="foc_qty"
                      :showLabel="false"
                      :disabled="false"
                      :value="item['foc_qty']||0"
                      :bb="'0px'"
                      @change="e => onTextFieldChange(e, item)"
                    /> 
                  </td>
                
                    
                
                    
                </tr>
                </template>
            </NTable>
         

       
            </div>
        
    </template>
    <template slot="options">
  

      <button class="dt-button s7 v1" @click="onOKClicked" >{{$t('add_to_order')}}</button>
      <button class="dt-button s7 v1" @click="onDoneClick" >{{$t('done')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';


import NTable from "../../../../plugins/datatable/datatable";








import ModalContainer from "@dtplugins/modal/modal-container";

import {  closeModalRoute  } from "../../../../dt-plugins/modal/modal.mixin";


import { createNTableConfig } from '../../../../plugins/datatable';

import { createTableHeader } from "../../../../plugins/datatable";



import {
  createTV,
  tv,
} from "../../../../models/text-value.model";


import { MHTTPCL } from '../../../../services/http/http-client';
import { SupplierOrdersService } from '../../services/supplier.order.service';

import { Subject } from "rxjs";
import { waitForAnimation, subscribeSubject } from "@/utility";

export default {
  components: {
    
    Modal,
    NTable,


    ModalContainer,   
    //AdvanceSearch,
   
  },
  mounted:async  function () {
    const modalInitData = await SupplierOrdersService.productTypes();
    console.log(modalInitData,":::::::::::::::::")
    this.productTypesList =modalInitData.data.product_types;


        subscribeSubject(this, this.searchSubject$, searchString => {
        
        SupplierOrdersService.searchProducts(this.supplier_order_id,searchString,this.product_type_id).then(res=>{
          console.log("SEARCH RES",res)
          this.list=res.data.products;
        });
        
       
      })
  },
  data: function () {
    return {

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },
      
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      }),

      list:[],

      productTypesList:[],

      searchSubject$: new Subject(),
      

      product_type_id:'',

      searchString: "",

    };
  },
  mixins: [
    
  ],

  computed: {
    Headers: function () {
      return [
        createTableHeader("catalog_no", { }),
        createTableHeader("artist", {  }),
        createTableHeader("title1", { text:'title' }),
        createTableHeader("format", { mw:65}),
       
        createTableHeader("cost_price", {ta:'center' ,mw:80}),

        createTableHeader("order_qty", {ta:'center'}),
        createTableHeader("foc", {ta:'center'}),

      ];
    },
    productTypesTV:function(){
      return createTV(this.productTypesList,'product_type_name','product_type_id')
    },

    supplier_order_id:function(){
      return this.$route.query.supplier_order_id;
    }
  
  
    
  },
  methods: { 
  
    onOKClicked:async function(){
      const arrayPayload = this.list.filter(e=>e.order_qty!=undefined).map(x=>{
        return{
          product_id:x.product_id,
          order_qty:x.order_qty,
          cost_price:x.cost_price,
          foc_qty:x.foc_qty
        }
      });

      // console.log(arrayPayload,"{{{{{}}}}}");

      await SupplierOrdersService.addMultipleProducts(this.supplier_order_id,arrayPayload);


    },
    onDoneClick:function(){
      this.$emit("onAdd",this.supplier_order_id)
    },

    onCancelClick: function() {
      this.$emit("cancelled", true);
    },

    onSearchInputKeyup: function(e) {
      this.searchString = e.target.value;
      console.log(this.searchString, e.target.value);
      this.searchSubject$.next(this.searchString);
    },

    onDropdownChange: async function (key,value) {
      
      this[key]=value.value
      //const supplier_order_id = this.$route.query.supplier_order_id
      const resProductList = await SupplierOrdersService.searchProducts(this.supplier_order_id,"",this.product_type_id); 
      console.log("VALUE",resProductList)

      this.list=resProductList.data.products;
    },
    
    onTextFieldChange: function(e, item) {
    
      this.list = this.list.map(x=>{
        if(x.product_id==item.product_id){
          if(e.name=='order_qty'){
            return {
              ...x,
              [e.name]: parseInt(e.value),
              foc_qty:x.foc_qty?x.foc_qty:0
            }
          }else{
            return {
              ...x,
              [e.name]: parseInt(e.value),
              order_qty:x.order_qty?x.order_qty:0
            }
          }
          
        }else{
          return x
        }
      })
   

      console.log("ARTIST",this.list);
    },



  
  },

  // [
  //   {"product_id":"76","order_qty":10,"cost_price":2.1,"foc_qty":10},
  //   {"product_id":"77","order_qty":20,"cost_price":2.1,"foc_qty":20}
  // ]
};
</script>